import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { Calendar, Clock, User, Phone, ArrowLeft } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
export function BlogPostPage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const navigate = useNavigate();
  const post = blogPosts.find(p => p.slug === slug);
  useEffect(() => {
    if (!post) {
      // Could redirect to 404 or back to blog
      // For now, we'll just let it render the "not found" state
    }
  }, [post, navigate]);
  if (!post) {
    return <div className="w-full min-h-screen bg-gray-50 flex flex-col" data-id="element-1037" data-mp="17f3hx1bnhdv3">
        <div className="flex-grow flex items-center justify-center" data-id="element-1038" data-mp="1cepxviiv587l">
          <div className="text-center" data-id="element-1039" data-mp="205ll02cdjf8i">
            <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-1040" data-mp="204k8dtfpmkoo">
              Post Not Found
            </h1>
            <Link to="/blog" className="text-blue-600 hover:text-blue-700 font-semibold flex items-center justify-center gap-2" data-id="element-1041" data-mp="24yoi2kgd16tg">
              <ArrowLeft size={20} data-id="element-1042" data-mp="gb42z569oq4a" /> Back to Blog
            </Link>
          </div>
        </div>
        <Footer data-id="element-1043" data-mp="u1zc8ikoh98e" />
      </div>;
  }
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-1044" data-mp="pahdm164nkql">
      <Helmet data-id="element-1045" data-mp="p8xum2t36vl4">
        <title data-id="element-1046" data-mp="p968ny0y46xw">{post.title} | I75 Audio & Video Blog</title>
        <meta name="description" content={post.metaDescription} data-id="element-1047" data-mp="13yltkxdspi5o" />
      </Helmet>

      {/* Blog Header */}
      <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-16 mt-16" data-id="element-1048" data-mp="yz90vw08tgv6">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1049" data-mp="1d0bkm23rmf2x">
          <Link to="/blog" className="inline-flex items-center text-blue-200 hover:text-white mb-6 transition-colors" data-id="element-1050" data-mp="180yzblsjlg2g">
            <ArrowLeft size={16} className="mr-2" data-id="element-1051" data-mp="3eryhgkac947b" /> Back to Blog
          </Link>
          <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-1052" data-mp="39tet6d89vgbs">
            {post.title}
          </h1>
          <div className="flex flex-wrap gap-6 text-blue-100" data-id="element-1053" data-mp="1dqrwfps6f67k">
            <div className="flex items-center gap-2" data-id="element-1054" data-mp="1ins4254och0s">
              <Calendar size={18} data-id="element-1055" data-mp="1iqeau2jqqshy" />
              <span data-id="element-1056" data-mp="1nmva9swe4tac">{post.date}</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1057" data-mp="1nm3eagyvstjj">
              <Clock size={18} data-id="element-1058" data-mp="1rp8egcvhoj50" />
              <span data-id="element-1059" data-mp="1rqjhubl0vovl">{post.readTime}</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1060" data-mp="1wol1oyq9vs84">
              <User size={18} data-id="element-1061" data-mp="1wlyux1b7hgqy" />
              <span data-id="element-1062" data-mp="21mwcpcsb08rx">{post.author}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Blog Content */}
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1063" data-mp="26exiqgyvp39i">
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-1064" data-mp="2bcpks3t8m5rf">
          <div className="prose prose-lg max-w-none prose-blue" data-id="element-1065" data-mp="2bf1z86zsdxzq">
            {post.content}
          </div>

          {/* Call to Action */}
          <div className="mt-12 p-6 bg-blue-50 rounded-lg border-l-4 border-blue-600" data-id="element-1066" data-mp="2kd463367bkux">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1067" data-mp="8q2765x62q6l">
              Need Professional Installation?
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-1068" data-mp="3q5xpr5pa6jn">
              Let our experts handle your AV installation from start to finish.
              We serve all of Southwest Florida with professional, reliable
              service.
            </p>
            <a href="tel:2392038333" className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-300" data-id="element-1069" data-mp="3qy9pfdikt89t">
              <Phone className="w-5 h-5 mr-2" data-id="element-1070" data-mp="io85kdjrle6p" />
              Call Now: (239) 203-8333
            </a>
          </div>
        </div>
      </article>

      <Footer data-id="element-1071" data-mp="dolotu4q9ft5" />
    </div>;
}